export default __webpack_public_path__ + "static/media/chevron-right-grey.080be20d.svg";